import { useIntl } from 'react-intl';
import { Toast } from 'components';
import { labelMessages } from './messages';
import { StyledToast, StyledContent, StyledBullets } from './styled';
import { ReconciliationToastType } from './types';

export const ReconciliationToast = ({
  handleDismiss,
  handleRetry,
  errorMessage,
  errorList
}: ReconciliationToastType): React.JSX.Element => {
  const intl = useIntl();
  return (
    <StyledToast>
      <Toast
        content={
          <StyledContent>
            {errorMessage}
            {errorList &&
              errorList.map(message => (
                <StyledBullets key={message}>{`\n${message}`}</StyledBullets>
              ))}
          </StyledContent>
        }
        buttonProps={[
          {
            onClick: () => handleDismiss(),
            text: intl.formatMessage(labelMessages.dismissButton)
          },
          {
            onClick: () => handleRetry(),
            text: intl.formatMessage(labelMessages.retryButton)
          }
        ]}
      />
    </StyledToast>
  );
};
